import { render, staticRenderFns } from "./FieldPropertyvalidator.vue?vue&type=template&id=8608b7e8&scoped=true&"
import script from "./FieldPropertyvalidator.vue?vue&type=script&lang=js&"
export * from "./FieldPropertyvalidator.vue?vue&type=script&lang=js&"
import style0 from "./FieldPropertyvalidator.vue?vue&type=style&index=0&id=8608b7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8608b7e8",
  null
  
)

export default component.exports